module.exports = __webpack_public_path__ + "static/media/Telegram-Message-Sample.f4bd47ea.png";